import React, {
    ReactElement,
} from "react";
import { Json } from "./base";
import { NamedParameters } from "./Template";
import Select from "../../../../components/select/Select";

export default function WorkflowServiceApiSelector({ json, onChange, rootJson }: {
    rootJson: Json;
    json: Json;
    onChange: (current: Json) => void;
}): ReactElement {
    const apis = (rootJson.apis ?? []) as Json[];
    const selectedApi = json?.apiId ? apis.find(api => api.id === json.apiId) : undefined;
    return (
        <div>
            <Select
                className="mb-2"
                onChange={apiId => onChange({
                    apiId: apiId.value,
                    parameters: json?.parameters,
                })}
                value={!selectedApi ? undefined : {
                    label: selectedApi.name as string,
                    value: selectedApi.id as string,
                }}
                options={apis.map(api => ({
                    label: api.name as string,
                    value: api.id as string,
                }))}
            />

            <NamedParameters
                json={json?.parameters as Json[] ?? []}
                onChange={parameters => onChange({
                    apiId: json?.apiId,
                    parameters,
                })}
            />

        </div>
    );
}
